import {
  NotificationType as NotificationTypeEnum,
  UserOrderNotificationSettingsType as UserOrderNotificationSettingsTypeEnum,
} from '../types/database/dispatch-svc';

export const NotificationType: Record<keyof typeof NotificationTypeEnum, keyof typeof NotificationTypeEnum> = {
  CLAIM_CREATE: 'CLAIM_CREATE',
  CLAIM_STATUS_CHANGE: 'CLAIM_STATUS_CHANGE',
  CLAIM_RESOLUTION: 'CLAIM_RESOLUTION',
  CLAIM_MESSAGES: 'CLAIM_MESSAGES',
  INTERNAL_NOTES: 'INTERNAL_NOTES',
  INTERNAL_NOTES_MENTION: 'INTERNAL_NOTES_MENTION',
  CLAIM_REVIEWS: 'CLAIM_REVIEWS',
  SOP_CREATE: 'SOP_CREATE',
  SOP_UPDATE: 'SOP_UPDATE',
  MACRO_CREATE: 'MACRO_CREATE',
  MACRO_UPDATE: 'MACRO_UPDATE',
  CLAIM_TAKEOVER_STALE: 'CLAIM_TAKEOVER_STALE',
  CLAIM_TAKEOVER_RETURNED: 'CLAIM_TAKEOVER_RETURNED',
} as const;

export const UserOrderNotificationSettingsType: Record<
  keyof typeof UserOrderNotificationSettingsTypeEnum,
  keyof typeof UserOrderNotificationSettingsTypeEnum
> = {
  NOT_SUBSCRIBED: 'NOT_SUBSCRIBED',
  SUBSCRIBED: 'SUBSCRIBED',
  CUSTOM: 'CUSTOM',
} as const;
